export const analyticsScript = `
(() => {
  window.dataLayer = window.dataLayer || [];
  window.gtag = window.gtag || function gtag(){dataLayer.push(arguments);};
  const loadAnalytics = () => {
    if (window.__playbrainAnalyticsLoaded) return;
    window.__playbrainAnalyticsLoaded = true;
    const script = document.createElement("script");
    script.async = true;
    script.src = "https://www.googletagmanager.com/gtag/js?id=G-ZVB90WM08K";
    document.head.appendChild(script);
    window.gtag("js", new Date());
    window.gtag("config", "G-ZVB90WM08K");
  };
  ["pointerdown", "keydown", "scroll", "touchstart"].forEach((eventName) => {
    window.addEventListener(eventName, loadAnalytics, { once: true, passive: true });
  });
})();
`
